import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppRoutes from "./routes/AppRoutes";
import "./web.css";
import "./App.css";
import ToastNotification from "./components/core/ToastNotifications";
import Loader from "./components/core/Loader";
import WelcomeModal from "./components/core/WelcomeModal";
import PasswordResetModal from "./components/core/PasswordResetModal";
import { userSelector } from "./redux/slices/userSlice";
import { setPasswordSelector, fetchUserDetailsThunk, setPasswordModalOpen } from "./redux/slices/setPassWordSlice";
import { AppDispatch } from "./redux/store";

function App() {
  const dispatch = useDispatch<AppDispatch>();
  const userData = useSelector(userSelector);

  const { isPasswordModalOpen, userDetails } = useSelector(setPasswordSelector);
  const welcomeVideoStatus = userData?.welcomeVideo?.status === 1 ? true : false;

  return (
    <>
      {/* <Loader /> */}
      {welcomeVideoStatus && <WelcomeModal />}
      {isPasswordModalOpen && (
        <PasswordResetModal
          open={isPasswordModalOpen}
          onClose={() => dispatch(setPasswordModalOpen(false))}
          userId={userDetails?.id || null}
        />
      )}
      <AppRoutes />
      <ToastNotification />
    </>
  );
}

export default App;